import { render, staticRenderFns } from "./SingleSlidePin.vue?vue&type=template&id=49265932&scoped=true&"
import script from "./SingleSlidePin.vue?vue&type=script&lang=js&"
export * from "./SingleSlidePin.vue?vue&type=script&lang=js&"
import style0 from "./SingleSlidePin.vue?vue&type=style&index=0&id=49265932&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49265932",
  null
  
)

component.options.__file = "SingleSlidePin.vue"
export default component.exports